import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./components/app/App";
import store from "./store";
import "./assets/style/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
